import {match} from 'ts-pattern';

type PinnedStyleParams = {
  pinned: 'LEFT' | 'RIGHT' | null | undefined;
  stickyTop: number;
  pinnedLeftOffset: number | undefined;
  pinnedRightOffset: number | undefined;
};

/**
 * Computes the CSS sticky style for a header cell based on its pinned state.
 *
 * Pinned headers get higher z-index so they cover non-pinned cells during horizontal scroll.
 * Non-pinned headers get lower z-index (still sticky for vertical scroll).
 */
export const computeHeaderCellPinnedStyle = (params: PinnedStyleParams) =>
  match(params.pinned)
    .with('LEFT', () => ({
      position: 'sticky' as const,
      top: params.stickyTop,
      left: params.pinnedLeftOffset ?? 0,
      zIndex: 'var(--z-content-loader)', // 120 — above non-pinned
    }))
    .with('RIGHT', () => ({
      position: 'sticky' as const,
      top: params.stickyTop,
      right: params.pinnedRightOffset ?? 0,
      zIndex: 'var(--z-content-loader)', // 120
    }))
    .otherwise(() => ({
      position: 'sticky' as const,
      top: params.stickyTop,
      zIndex: 'var(--z-content)', // 100 — below pinned
    }));
